import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import FlowIcon from '../illustrations/FlowIcon';
import AdaptiveIcon from '../illustrations/AdaptiveIcon';

const WhyEngage = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section ref={ref} className="py-16 md:py-32 px-4 sm:px-6 bg-gray-50 relative">
      <div className={`max-w-6xl mx-auto transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}>
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-12 md:mb-20 text-center">
          Every click feels personal.
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 items-start">
          <div className="text-center">
            <div className="bg-white p-6 md:p-8 rounded-2xl mb-6 h-48 md:h-64 flex items-center justify-center">
              <FlowIcon className="text-black scale-110 md:scale-125" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">Flow-based design</h3>
            <p className="text-gray-600 text-sm md:text-base">One question at a time. Natural rhythm.</p>
          </div>
          
          <div className="text-center md:mt-20">
            <div className="bg-white p-6 md:p-8 rounded-2xl mb-6 h-48 md:h-64 flex items-center justify-center">
              <svg className="text-black scale-125 md:scale-150" width="100" height="100" viewBox="0 0 100 100" fill="none">
                <circle cx="50" cy="50" r="30" stroke="currentColor" strokeWidth="3" fill="none"/>
                <path d="M35 50 L 45 60 L 65 40" stroke="#00FFC6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">Micro-interactions</h3>
            <p className="text-gray-600 text-sm md:text-base">Each tap feels alive.</p>
          </div>
          
          <div className="text-center">
            <div className="bg-white p-6 md:p-8 rounded-2xl mb-6 h-48 md:h-64 flex items-center justify-center">
              <AdaptiveIcon className="text-black scale-110 md:scale-125" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">Adaptive logic</h3>
            <p className="text-gray-600 text-sm md:text-base">Responds intelligently to choices.</p>
          </div>
        </div>
        
        <div className="text-center mt-12 md:mt-16">
          <p className="text-lg md:text-xl text-gray-700">
            Fylo adapts to how people respond.<br className="hidden sm:block" />
            It shows one question at a time, uses motion to guide focus<br className="hidden sm:block" />
            and rewards progress, turning friction into flow.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyEngage;